module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "startCheck"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingShow),
      expression: "!loadingShow"
    }]
  }, [_vm._v(_vm._s(_vm.examInfo.examName) + "\n  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.examInfo.canAnwser == 1),
      expression: "examInfo.canAnwser == 1"
    }],
    ref: "startCheck",
    staticStyle: {
      "margin-top": "46px"
    }
  }, [(_vm.examInfo.attention) ? _c('div', {
    staticClass: "exam-attention",
    domProps: {
      "innerHTML": _vm._s(_vm.examInfo.attention)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.currentModule.subjects), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "exam-div"
    }, [_c('checkChoice', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.choices.subjectSex == _vm.personInfo.sexCode || item.choices.subjectSex == ''),
        expression: "item.choices.subjectSex == personInfo.sexCode || item.choices.subjectSex == ''"
      }],
      ref: item.id,
      refInFor: true,
      attrs: {
        "choice": item,
        "cuIndex": i + 1
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "btnGroup",
    staticStyle: {
      "margin": "25px auto"
    },
    attrs: {
      "align": "center"
    }
  }, [(_vm.currentModuleIndex > 0) ? _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingShow),
      expression: "!loadingShow"
    }],
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.pre($event)
      }
    }
  }, [_vm._v("上一页")]) : _vm._e(), _vm._v(" "), (_vm.currentModuleIndex < _vm.modules.length - 1) ? _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingShow),
      expression: "!loadingShow"
    }],
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.next($event)
      }
    }
  }, [_vm._v("下一页")]) : _vm._e(), _vm._v(" "), (_vm.modules.length - 1 == _vm.currentModuleIndex) ? _c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingShow),
      expression: "!loadingShow"
    }],
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.subCommit($event)
      }
    }
  }, [_vm._v("提 交")]) : _vm._e(), _vm._v(" "), (_vm.examInfo.end) ? _c('div', {
    staticClass: "exam-attention",
    domProps: {
      "innerHTML": _vm._s(_vm.examInfo.end)
    }
  }) : _vm._e()], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.examInfo.canAnwser == 2),
      expression: "examInfo.canAnwser == 2"
    }],
    staticClass: "paper",
    staticStyle: {
      "margin-top": "46px",
      "font-size": "16px"
    }
  }, [_c('div', {
    staticClass: "module-chart"
  }, [_c('grid', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.personModule.length > 1),
      expression: "personModule.length > 1"
    }],
    attrs: {
      "cols": _vm.personModule.length <= 3 ? _vm.personModule.length : 3,
      "show-lr-borders": false,
      "show-vertical-dividers": false
    }
  }, _vm._l((_vm.personModule), function(item, i) {
    return _c('grid-item', {
      key: i
    }, [_c('div', [_c('span', [_vm._v(_vm._s(item.score))]), _c('br'), _vm._v(_vm._s(item.moduleName) + "\n          ")])])
  }))], 1), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), (_vm.personResult.score > 0) ? _c('div', {
    staticClass: "xxl-font text-center",
    staticStyle: {
      "color": "#4ba7e8"
    }
  }, [_c('span', {
    attrs: {
      "id": "total"
    }
  }, [_vm._v(_vm._s(_vm.personResult.score))]), _vm._v("分")]) : _vm._e(), _vm._v(" "), (_vm.personResult.evalLevel != '') ? _c('div', {
    staticClass: "xl-font text-center",
    staticStyle: {
      "color": "#4ba7e8"
    }
  }, [_c('span', {
    attrs: {
      "id": "phytype"
    }
  }, [_vm._v(_vm._s(_vm.personResult.evalLevel))])]) : _vm._e(), _vm._v(" "), (_vm.examInfo.remark && _vm.examInfo.empNo == '') ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('p', {
    staticClass: "m-font gray-text"
  }, [_vm._v(_vm._s(_vm.examInfo.remark))])]) : _vm._e(), _vm._v(" "), (_vm.queryParam.examinationId === '1255028861662404609') ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('hr'), _vm._v(" "), (_vm.vip === '1') ? _c('p', {
    staticClass: "m-font gray-text"
  }, [_vm._v("您的测评结果已完成，请前往6楼VIP中医门诊进行结果分析及报告打印（需先在6楼前台分诊），谢谢！")]) : _vm._e(), _vm._v(" "), (_vm.vip === '2' || _vm.vip === '' || _vm.vip === 'undefined') ? _c('p', {
    staticClass: "m-font gray-text"
  }, [_vm._v("您的测评结果已完成，请前往门诊3楼中医门诊进行结果分析及报告打印（需先前往咨询台分号），谢谢！")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.personResult.eval && _vm.queryParam.examinationId !== '1255028861662404609') ? _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "cyan-text l-font"
  }, [_vm._v("测评描述")]), _vm._v(" "), _c('p', {
    staticClass: "m-font gray-text"
  }, [_vm._v(_vm._s(_vm.personResult.eval))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.personResult.suggest) ? _c('p', {
    staticClass: "m-font gray-text",
    domProps: {
      "innerHTML": _vm._s(_vm.personResult.suggest)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showImg) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.showImg
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": "加载中..."
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center strip-div white-text l-font",
    staticStyle: {
      "background": "url('https://front.cd.jinxin-fertility.com/static/images/strip.png') no-repeat",
      "background-size": "100%",
      "background-position": "center"
    }
  }, [_c('div', [_vm._v("你的综合得分")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86f630ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/exam/startCheck.vue
// module id = wd1D
// module chunks = 5